import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, MaskLines } from "../components/Reveal";

const TERMS_SECTIONS = [
  {
    title: "Acceptance of Terms",
    body: "By accessing dharakalamovies.com you agree to these Terms & Conditions. If you do not agree, please discontinue use of the site.",
  },
  {
    title: "Intellectual Property",
    body: "All content — including film titles, artwork, posters, synopses, photography, video, logos and written material — is the property of Dhara Kala Movies or its licensors and is protected by copyright. No content may be reproduced, distributed or used without prior written permission.",
  },
  {
    title: "Project Information",
    body: "Details about our film slate, production status, cast and festival objectives are presented in good faith. Production plans, release dates and creative teams may change. No content on this site constitutes an offer, promise or guarantee of participation, selection or distribution.",
  },
  {
    title: "Third-Party Links",
    body: "The website may reference third-party services, festivals or markets for informational purposes. We are not responsible for the content, availability or practices of any external service.",
  },
  {
    title: "Limitation of Liability",
    body: "To the maximum extent permitted by law, Dhara Kala Movies is not liable for any indirect, incidental or consequential damages arising from use of the site.",
  },
  {
    title: "Contact",
    body: "For any question regarding these terms, please write to dharakala@outlook.com.",
  },
];

export default function Terms() {
  return (
    <main data-testid="terms-page" className="bg-black pt-32 md:pt-40 min-h-screen">
      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pb-16">
        <Link to="/" className="text-[11px] uppercase tracking-overline text-white/60 hover:text-white inline-flex items-center gap-2 mb-8">
          <ArrowLeft size={14} /> Home
        </Link>
        <p className="text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)] mb-6">Terms & Conditions</p>
        <h1 className="font-serif-display font-light text-white text-6xl md:text-8xl leading-[0.9] tracking-tighter">
          <MaskLines lines={["Terms,", "clearly."]} />
        </h1>
        <Reveal delay={1} className="mt-8 text-white/50 text-sm">Last updated: December 2026</Reveal>
      </section>

      <section className="max-w-[1200px] mx-auto px-6 md:px-10 pb-28 space-y-14">
        {TERMS_SECTIONS.map((s, i) => (
          <Reveal key={i} delay={i % 3} className="grid grid-cols-1 md:grid-cols-12 gap-6 border-t border-white/10 pt-10">
            <p className="md:col-span-2 text-[10px] uppercase tracking-overline text-[color:var(--dk-gold)]/70">
              0{i + 1}
            </p>
            <div className="md:col-span-10">
              <h2 className="font-serif-display text-white text-2xl md:text-3xl mb-4">{s.title}</h2>
              <p className="text-white/70 leading-relaxed max-w-3xl">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </section>
    </main>
  );
}
